import ReactRoute from "./reactRoute/ReactRoute";

function App() {
  return (
    <div className="w-full flex flex-col items-center justify-center">
      <ReactRoute />
    </div>
  );
}

export default App;